import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

import { mapGuideStatusFromDTO } from '../mappers/guide-status.mapper';
import { GuideStatus } from '../types/guide';
import { GuideStatusResponse } from '../types/response/guide-status-response';

export const getGuideStatus = async (): Promise<GuideStatus> => {
  const endpoint = '/api/guide/status';

  const response = await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.get<{ data: GuideStatusResponse }>(endpoint)
  );

  return mapGuideStatusFromDTO(response);
};

export const completeGuideItem = async (item: string): Promise<void> => {
  const endpoint = '/api/guide/complete-item';

  await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.post(endpoint, { item })
  );
};

export const dismissGuide = async (): Promise<void> => {
  const endpoint = '/api/guide/dismiss';

  await withApiErrorHandler(endpoint, ApiErrorCode.GENERIC_ERROR, () =>
    axiosInstance.patch(endpoint)
  );
};
